import { Box, MenuItem, Select, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const FormSelect = ({ Icon, label, placeholder, options, value, onChange, disabled = false }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, width: 1 }}>
      <Box sx={{ display: "flex", gap: 0.75 }}>
        <Icon size={16} style={{ color: theme.palette.text.navigation, marginTop: "auto", marginBottom: "auto" }} />
        <Typography variant="Textbox Label">{t(label)}</Typography>
      </Box>
      <Box sx={{}}>
        <Select
          fullWidth
          displayEmpty
          sx={{
            "& .MuiInputBase-input": { fontSize: 14, height: 14, fontFamily: "Poppins", textAlign: "left" },
            "& .MuiOutlinedInput-root": {
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#d1d5db", borderWidth: 1 },
              "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#10b981", borderWidth: 2 },
              },
            },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#10b981" },
            "& .MuiSelect-select": {
              paddingY: 0.75,
              paddingX: 1.5,
              "&.Mui-focused": { "& .MuiSelect-outlined": { borderColor: "#10b981", borderWidth: 2 } },
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#10b981", borderWidth: 2 },
          }}
          MenuProps={{
            slotProps: { paper: { sx: { maxHeight: 200 } } },
            sx: { "&& .Mui-selected": { backgroundColor: "rgba(16, 185, 129, 0.25)" } },
          }}
          value={value}
          onChange={onChange}
          disabled={disabled}>
          {options.map((o, i) => {
            const menuItemSx = {
              paddingY: 0.5,
              paddingX: 1.5,
              fontSize: 14,
              fontFamily: "Poppins",
              "&:hover": {
                backgroundColor: "rgba(16, 185, 129, 0.1)",
              },
            };
            if (o.value && o.label) {
              return (
                <MenuItem key={i} value={o.value} sx={menuItemSx}>
                  {t(o.label)}
                </MenuItem>
              );
            } else if (o.label) {
              return (
                <MenuItem key={i} value={o.label} sx={menuItemSx}>
                  {t(o.label)}
                </MenuItem>
              );
            } else if (o) {
              return (
                <MenuItem key={i} value={o} sx={menuItemSx}>
                  {t(o)}
                </MenuItem>
              );
            } else {
              return;
            }
          })}
        </Select>
      </Box>
    </Box>
  );
};
export default FormSelect;
